import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Image, Row, Col} from 'react-bootstrap';
import SMTPIcon from 'src/legacy/images/smtp_logo.png';
import SmtpConfigurationPage from './SmtpConfigurationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import BackButton from 'src/legacy/components/BackButton';
import styles from './styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';

class SmtpView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      deleteConfirmation: false
    };

    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedSMTP= localizedStrings.components.integrations.smtp;
    this.localizedCommons = localizedStrings.commons;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
}

  componentDidMount() {
    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
    {this.props.integration && this.props.fetchSmtpIntegration(); }
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }

  render(){
    if (this.props.loading) {
      return this._renderLoadingMessage();
    }

    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            
            <BackButton className={styles.back} title={ this.localizedCommons.actions.back } onClick={() => {
              this.props.handleIntegrationsBackButton();
            }} />

            <div className={ styles.heading }>
              <Image src={SMTPIcon} />
              <h2 className={styles.name}>{ this.localizedSMTP.title }</h2>
              <p className={styles.description}>
                { this.localizedSMTP.sub_text }
              </p>
              <p className={styles.description}>
                { this.localizedSMTP.description }
              </p>
              {this.props.integration && this.props.integration.state.code === "ok" &&
                <button className={styles.button} disabled={this.props.deactivating} onClick={this._handleDeactivateClicked}>
                  {this.props.deactivating && `${this.localizedIntgerationActions.deactivating}...`}
                  {!this.props.deactivating && this.localizedIntgerationActions.deactivate}
                </button>
              }
            </div>  

          </Col>
          <Col md={9} className={styles.right}>
            <SmtpConfigurationPage store={this.context.store} />
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name = {this.localizedSMTP.title}
          type="smtp"
          message = {`${this.localizedSMTP.deactivate_slider}: ${this.props.integration && this.props.integration.configuration.userName || ''}`}
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
            deleteConfirmation: false
           })
          }}
        />
      </div>
    );
  }

  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={`${this.localizedCommons.loading}...`}
        visible={this.props.loading}
      />
    )
  }
}

export default SmtpView;